// Module
var code = "<md-icon class=\"bringoz-icon-large margin-0\" md-svg-icon=\"{{$ctrl.type === 'Curbside' ? 'privatecar' : 'home'}}\" aria-label=\"Pickup Type\"> <md-tooltip>{{$ctrl.type | translate}}</md-tooltip> </md-icon> ";
// Exports
export default code;